module.exports = __webpack_public_path__ + "img/arrow-logout-right-alt.2a4fe281.svg";